import { atom } from "jotai";

export const overlay_state = atom({
  filter: false,
  property: false,
  selectFunction: false,
  sort: false,
  hardcodedetail: false,
  detail: false,
});


